<template>
    <div class="testContent">
        <div class="flex ai-c jc-sb">
            <div class="flex ai-c col-2">
                <el-input v-model="query.condition.qbname" class="mr-10" size="medium" placeholder="考试名称" clearable></el-input>
                <div class="flex aic-c ml-10">
                    <el-button @click="() => getCoursExamConfigList(query)" type="primary" icon="el-icon-search" plain>搜索</el-button>
                    <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
                </div>
            </div>
        </div>
        <div class="mt-20">
            <el-button @click="addClass" type="primary"><span class="icon-add">+</span>新增配置</el-button>
        </div>
        <el-table :data="testInfoList" v-loading="loading" border class="mt-20 table-fixed-col">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="考试名称" prop="examname" key="examname" align="center" fixed min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span @click="testDetail(scope.row)" class="color-primary pointer">{{scope.row.examname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="考试开始时间" key="starttime" prop="starttime" align="center" fixed min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="考试结束时间" prop="endtime" key="endtime" align="center" fixed min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="考试时长（分钟）" prop="examlength" key="examlength" align="center" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column label="最低过关分数" prop="minscore" key="minscore" align="center" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="参与考试次数" prop="maxjoincount" key="maxjoincount" align="center" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="完成考试次数" prop="totalfinishcount" key="totalfinishcount" align="center" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="考试过关次数" prop="totalpasscount" key="totalpasscount" align="center" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="过关率" prop="passrate" key="passrate" align="center" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :width="getTableHeaderWidthByOpButton2()" fixed="right" key="set" align="right" label="操作">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sb ai-c pointer">
                            <span v-if="scope.row.totalfinishcount<1"  @click="del(scope.row)"  class="color-brand pointer">删除</span>
                            <span v-if="scope.row.totalfinishcount<1" @click="edit(scope.row)" class="color-brand pointer">编辑</span>
                            <span @click="goTestList(scope.row)" v-else class="color-brand pointer">参与情况</span>   
                        </div>
                    </template>
                </el-table-column>
        </el-table>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="queryCache.page"
            background
        ></el-pagination>
        <!-- 新增配置 -->
        <AddTest ref="AddTest" />
    </div>
</template>
<script>
import { getCoursExamConfigList ,updateCourseExamConfigStatus} from '@/api/measApi/teachManagement'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import { deepClone } from '@/common/js/tools'
import AddTest from './components/addTest.vue'
export default {
    data: () => ({
        total: 0,
        loading: false,
        testInfoList: [],
        query: {
            condition: {
                classcode: '',
                classcoursecode: '',
                endtime: '',
                starttime: '',
                qbname: ''
            },
        },
        queryCache: {
            page: 1,
            pagesize: getTableDefaultPageSize(),
        },
        delParams: {
            codes: '',
            status: '100'
        },
        step: 1
    }),
    props: {
        // 课程code
        courseCode: {
            require: true,
            type: String,
        },
        // 班级code
        classCode: {
            require: true,
            type: String,
        }
    },
    components: {
        AddTest
    },
    created() {
        Object.assign(this.queryCache, deepClone(this.query))
        //  this.getCoursExamConfigList()
    },
    methods: {
        init() {
            if(this.step === 1){
                this.getCoursExamConfigList()
            }
        },
        reset() {
            this.query.condition.qbname = ''
            this.queryCache.page = 1
            this.getCoursExamConfigList()
        },
        addClass(){
            this.$refs.AddTest.init()
        },
        // 获取考试配置列表
        async getCoursExamConfigList(param) {
            if (param) {
                this.queryCache.page = 1
            }
            Object.assign(this.queryCache, deepClone(param))
            this.queryCache.condition.classcode = this.classCode
            this.queryCache.condition.classcoursecode = this.courseCode
            this.loading = true
            try {
                const res = await getCoursExamConfigList(this.queryCache)
                console.log(res,'res配置')
                this.step++
                if (res.code === '000') {
                    this.testInfoList = res.data
                    this.total = res.pageinfo.rowcount
                }
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        del(row){
            this.delParams.codes = row.code
            updateCourseExamConfigStatus(this.delParams).then(res => {
                if(res.code === '000'){
                    this.$message.success(res.msg)
                    this.queryCache.page = 1
                    this.getCoursExamConfigList()
                }else{
                     this.$message.error(res.msg)
                }
            })
        },
        edit(row){
            this.$refs.AddTest.init(row.code)
        },
        // 导出学员学情列表
        // async exportStudentStudyList() {
        //     this.queryCache.condition.classcoursecode = this.courseCode
        //     await exportStudentStudyList(this.queryCache, '下载.xlsx')
        // },
        // 序号格式化
        indexFormatter(index) {
            return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.queryCache.page = 1
            this.queryCache.pagesize = e
            this.getCoursExamConfigList()
        },
        // 页面跳转
        curPageChange(e) {
            this.queryCache.page = e
            this.getCoursExamConfigList()
        },
        // 参与情况
        goTestList(row){
            this.$emit('goTestList', row)
        },
        testDetail(row){
            this.$refs.AddTest.init(row.code, true)
        }
    },
}
</script>
<style lang="scss" scoped>
.testContent{
    padding: 2px;
    .el-button {
        margin-bottom: 0 !important;
    }
    ::v-deep .el-input,
    .el-select {
        height: 36px !important;

        > .el-input {
            height: 36px !important;
        }
    }
}
</style>
